import { render, staticRenderFns } from "./CaAlerts.vue?vue&type=template&id=7c09415c&"
import script from "./CaAlerts.vue?vue&type=script&lang=js&"
export * from "./CaAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports